export const getTaskById = (state) => (th) => {
  return state.tasks.find(x => x.th === th)
}

export const getNewTasks = (state) => {
  const currentDate = new Date(Date.now())
  const statuses = ['progress_invite', 'progress_remind']
  const taskFilter = (t) => {
    return statuses.includes(t.field['progress']) &&
      new Date(t['field'].frm_date_end) >= currentDate &&
      (t.field['frm_status'] === '1' || t.field['frm_status'] === 1)
  }

  return state.tasks.filter(taskFilter)
}

export const getBusyTasks = (state) => {
  const currentDate = new Date(Date.now())
  const allowedStatuses = ['progress_busy']
  const taskFilter = (t) => {
    return allowedStatuses.includes(t.field['progress']) &&
      new Date(t['field'].frm_date_end) >= currentDate &&
      (t.field['frm_status'] === '1' || t.field['frm_status'] === 1)
  }

  return state.tasks.filter(taskFilter)
}

export const getAllOpenTasks = (state) => {
  const currentDate = new Date(Date.now())
  const allowedStatuses = ['progress_invite', 'progress_busy', 'progress_done', 'progress_remind']
  const taskFilter = (t) => {
    return allowedStatuses.includes(t.field['progress']) &&
      new Date(t['field'].frm_date_end) >= currentDate &&
      (t.field['frm_status'] === '1' || t.field['frm_status'] === 1)
  }

  return state.tasks.filter(taskFilter)
}
